
function Modal() {
  var _this = this;
  this.showModalBg = function() {
    $('.js-modal-bg').fadeIn();

    this.showModalBlur();
    $('body').addClass('body--modal-open');
  };

  this.showModalBlur = function() {
    $('.js-header, .js-main, .js-footer').addClass('modal--blur');
  };

  this.hideModalBlur = function() {
    $('.js-header, .js-main, .js-footer').removeClass('modal--blur');
  };

  this.hideModalBg = function() {
    this.hideModalBlur();
    $('.js-modal-bg').fadeOut();

    $('body').removeClass('body--modal-open');
  };

  this.hideModal = function() {
    $('.js-modal').fadeOut();
  };

  this.hideModalFull = function() {
    _this.hideModalBg();
    _this.hideModal();
  };

  $('.js-modal-bg').on('click', function(event) {
    event.preventDefault();
    if (!$(event.target).closest('.js-modal').length) {
      _this.hideModalBg();
      _this.hideModal();
    }
  });

  $('.js-modal__close').on('click', function(event) {
    event.preventDefault();
    _this.hideModalBg();
    _this.hideModal();
  });
}
